import { apolloClient } from './ApolloClient';
import { gql } from '@apollo/client';
import type { CreateUserInput, UpdateUserInput } from '../types/cognitoUser';

interface ListUsersParams {
  limit?: number;
  nextToken?: string;
}

/**
 * Service class for Cognito user management operations (GS-USER-ADMIN only)
 */
export class UserService {
  async listUsers(params: ListUsersParams = {}) {
    const LIST_USERS = gql`
      query ListUsers($limit: Int, $nextToken: String) {
        listUsers(limit: $limit, nextToken: $nextToken) {
          users {
            username
            email
            name
            enabled
            userStatus
            createdAt
            organization
          }
          nextToken
        }
      }
    `;

    const result = await apolloClient.query({
      query: LIST_USERS,
      variables: params,
      fetchPolicy: 'no-cache',
    });

    return { data: result.data, errors: result.errors };
  }

  async getUser(username: string) {
    const GET_USER = gql`
      query GetUser($username: String!) {
        getUser(username: $username) {
          username
          email
          name
          enabled
          userStatus
          createdAt
          organization
          groups
        }
      }
    `;

    const result = await apolloClient.query({
      query: GET_USER,
      variables: { username },
    });

    return { data: result.data, errors: result.errors };
  }

  async createUser(input: CreateUserInput) {
    const CREATE_USER = gql`
      mutation CreateUser($input: CreateUserInput!) {
        createUser(input: $input) {
          username
          email
          name
          enabled
          userStatus
          createdAt
          organization
          groups
        }
      }
    `;

    console.log('=== UserService.createUser input:', input);
    const result = await apolloClient.mutate({
      mutation: CREATE_USER,
      variables: { input },
    });
    console.log('=== UserService.createUser full result:', JSON.stringify(result, null, 2));

    return { data: result.data, errors: result.errors };
  }

  async updateUser(input: UpdateUserInput) {
    const UPDATE_USER = gql`
      mutation UpdateUser($input: UpdateUserInput!) {
        updateUser(input: $input) {
          username
          email
          name
          enabled
          userStatus
          createdAt
          organization
          groups
        }
      }
    `;

    const result = await apolloClient.mutate({
      mutation: UPDATE_USER,
      variables: { input },
    });

    return { data: result.data, errors: result.errors };
  }

  async deleteUser(username: string) {
    const DELETE_USER = gql`
      mutation DeleteUser($username: String!) {
        deleteUser(username: $username) {
          username
          email
          name
        }
      }
    `;

    const result = await apolloClient.mutate({
      mutation: DELETE_USER,
      variables: { username },
    });

    return { data: result.data, errors: result.errors };
  }

  async disableUser(username: string) {
    const DISABLE_USER = gql`
      mutation DisableUser($username: String!) {
        disableUser(username: $username) {
          username
          email
          name
          enabled
        }
      }
    `;

    const result = await apolloClient.mutate({
      mutation: DISABLE_USER,
      variables: { username },
    });

    return { data: result.data, errors: result.errors };
  }

  async enableUser(username: string) {
    const ENABLE_USER = gql`
      mutation EnableUser($username: String!) {
        enableUser(username: $username) {
          username
          email
          name
          enabled
        }
      }
    `;

    const result = await apolloClient.mutate({
      mutation: ENABLE_USER,
      variables: { username },
    });

    return { data: result.data, errors: result.errors };
  }
}

export default UserService;
